
<div class="py-6">
  <app-table
    [loading]="loading"
    [data]="committees"
    [columns]="committeeTableColumns"
    id="nom-org-table"
  />
</div>
